import template from './account.html';
import controller from './account.controller.js'

const profileAccountComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default profileAccountComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/account/account.component.js
 **/